import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} in deiner Umgebung gemeldet",
  "alert.toast.escalation": "{hazard} in der Nähe hat sich verschärft",
  "alert.toast.inPath": "{hazard} bewegt sich auf deinen Standort zu",
  "alert.toast.allClear": "Lage normalisiert bei {place}",
  "alert.toast.tap": "Öffnen für Details und Sicherheitsmaßnahmen",
  "alert.takeover.title": "{hazard} — sofortiges Handeln erforderlich",
  "alert.takeover.details": "Vollständigen Bericht anzeigen",
  "now.status.allClear": "Keine aktiven Gefahren.",
  "now.status.stayAware": "Aufmerksam bleiben.",
  "now.status.sub.allClear": "Keine aktiven Gefahren innerhalb deines Überwachungsradius.",
  "now.activity.empty": "Keine gemeldeten Ereignisse in der Nähe.",
  "onboarding.promise.tagline": "Ein gemeinschaftliches Frühwarnnetz.",
  "onboarding.promise.continue": "Starten",
  "region.unsupported.title": "Standort außerhalb des Versorgungsbereichs",
  "you.voice.intro": "Wähle den Ton, in dem Beacon mit dir kommuniziert.",
};
